import './styles/navbar.css';
import React, {useState} from 'react';
import {FaArtstation,FaHome,FaWindowClose,FaProjectDiagram,FaAngellist} from 'react-icons/fa';
import {BiWinkSmile} from 'react-icons/bi';
function NavBar(){

    const [turn, setTurn] = useState(0);

    const Navone = ()=>(
        <div className="navb" id="myNavb">
            
            <a className="actve" href='/'><FaHome size={"25px"}/> Home</a>
            <a href='/about'><FaArtstation size={"20px"}/> About</a>
            <a href='/projects'><FaProjectDiagram size={"20px"}/> Projects</a>                    
            <a href='/blogs'><FaAngellist size={"20px"}/>Blogs</a>

            <a href="javascript:void(0)" className="icon1" onClick={()=>setTurn(1)}>
            <i className="material-icons">&#xe5d2;</i>
            </a>              

        </div>
    )
    const Navtwo = ()=>(
        <div className="navbresponsive" id="myNavb">
            <center><BiWinkSmile size={"60px"}/></center>
            <h1>Ishaan</h1><br/>
            <a className="actve" href='/'><FaHome size={"25px"}/> Home</a>
            <a href='/about'><FaArtstation size={"20px"}/> About</a>
            <a href='/projects' ><FaProjectDiagram size={"20px"}/> Projects</a>                    
            <a href='/blogs' ><FaAngellist size={"20px"}/>Blogs</a> 

            <a href="javascript:void(0)" className="icon2" onClick={()=>setTurn(0)}>
            <FaWindowClose size={"35px"}/>
            </a>                  
        </div>
    )
    return(
        <>
        {
            (turn===0)?(
                <Navone/>
            ):(
                <Navtwo/>
            )
        }
        </>
    );
    
}
export default NavBar;